export default __webpack_public_path__ + "static/media/Group 6026.c5e9383d.png";